import { laadModule } from './modules/laadModule';
import React, { Component, Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Login } from './components/account/Login';
import { PageNotFound } from './components/util/PageNotFound';
import PrivateRoute from './components/util/PrivateRoute';
import { ToastContainer } from 'react-toastify';

// Lazy: de app boot met alleen Login; elke andere route laadt pas bij bezoek.
const Main = lazy(() => laadModule(() => import('./components/Main').then(m => ({ default: m.Main }))));
const WedstrijdleiderPagina = lazy(() => laadModule(() => import('./components/wedstrijdleider/WedstrijdleiderPagina').then(m => ({ default: m.WedstrijdleiderPagina }))));
const ParticipantLogin = lazy(() => laadModule(() => import('./components/participant/participantPage/ParticipantLogin').then(m => ({ default: m.ParticipantLogin }))));
const ParticipantLayoutOverview = lazy(() => laadModule(() => import('./components/participant/participantPage/ParticipantLayoutOverview').then(m => ({ default: m.ParticipantLayoutOverview }))));
const Scorebord = lazy(() => laadModule(() => import('./components/scorebord/Scorebord').then(m => ({ default: m.Scorebord }))));

export default class App extends Component {
    render() {
        return (
            <div>
                <Suspense fallback={<div className="laden">Bezig met laden</div>}>
                    <Switch>
                        <Route path='/login/' component={Login} />
                        <Route exact path='/wedstrijdleider' component={WedstrijdleiderPagina} />
                        <Route exact path='/wedstrijdleider/:code' component={WedstrijdleiderPagina} />
                        <Route exact path='/code/:code' component={ParticipantLogin} />
                        <Route exact path='/code/:code/:number' component={ParticipantLayoutOverview} />
                        {/* Het scorebord hangt aan een beamer: geen menubalk, geen kader. */}
                        <PrivateRoute exact path='/scorebord/:tournamentId' component={Scorebord} />
                        <Route path='/' component={Main} />
                        <Route path='*' component={PageNotFound} />
                    </Switch>
                </Suspense>
                <ToastContainer position="top-right" autoClose={3000} />
                <div className="pop-up-helper" />
            </div>
        );
    }
}
